export const tokens = {
  spacing: (key) => `var(--spacing-${key})`,
  container: (key) => `var(--container-${key})`,
  breakpoint: (key) => `var(--breakpoint-${key})`,
  fontFamily: (key) => `var(--font-family-${key})`,
  fontWeight: (key) => `var(--font-weight-${key})`,
  fontSize: (key) => `var(--${key}-size)`,
  lineHeight: (key) => `var(--${key}-line-height)`,
  color: (key) => `var(--color-${key})`,
};
